import React, { FunctionComponent, useState } from "react"
import { Typography, Card, CardContent, Collapse, IconButton, Grid } from "@material-ui/core"
import { TransactionModel } from "./TransactionsTable"
import { TransactionAction } from "../../common/enums"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight"
import {
    ApproveAudioMetadata,
    CreateAudioMetadata,
    TranslateTextMetadata,
    UploadAudioMetadata
} from "../../common/interfaces"
import styles from "./TransactionCard.module.scss"
import { TimeStamp } from "../../components/TimeStamp"

export interface TransactionCardProps {
    transaction: TransactionModel
}
interface metadataInterface {
    label: string
    data: string
}

export const TransactionCard: FunctionComponent<TransactionCardProps> = ({ transaction }) => {
    let transactionAction
    let transactionMetadata: metadataInterface[] = []
    switch (transaction.action) {
        case TransactionAction.TRANSLATE_TEXT:
            transactionAction = "Translate Text"
            transactionMetadata.push(
                {
                    label: "Source Language Code",
                    data: (transaction.metadata as TranslateTextMetadata).sourceLanguageCode
                },
                {
                    label: "Target Language Code",
                    data: (transaction.metadata as TranslateTextMetadata).targetLanguageCode
                },
                {
                    label: "Text",
                    data: (transaction.metadata as TranslateTextMetadata).text
                }
            )
            break
        case TransactionAction.GENERATE_AUDIO:
            transactionAction = "Generate Audio"
            transactionMetadata.push(
                {
                    label: "Language Code",
                    data: (transaction.metadata as CreateAudioMetadata).languageCode
                },
                {
                    label: "Voice",
                    data: (transaction.metadata as CreateAudioMetadata).voice
                }
            )
            break
        case TransactionAction.APPROVE_AUDIO:
            transactionAction = "Approve Audio"
            transactionMetadata.push({
                label: "File Size",
                data: (transaction.metadata as ApproveAudioMetadata).fileSize
            })
            break
        case TransactionAction.UPLOAD_AUDIO:
            transactionAction = "Upload Audio"
            transactionMetadata.push({
                label: "File Size",
                data: (transaction.metadata as UploadAudioMetadata).fileSize
            })
            break
        default:
            transactionAction = ""
            break
    }

    const [open, setOpen] = useState<boolean>(false)

    return (
        <div>
            <Card variant="outlined" style={{ paddingBottom: 0, paddingTop: 0 }}>
                <CardContent className={`${styles.Shaded__light} transaction-card`}>
                    <Grid container alignItems="flex-end" spacing={6}>
                        <Grid item>
                            <IconButton
                                size="small"
                                onClick={() => setOpen(!open)}
                                data-testid="openButton"
                                className="openButton"
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowRightIcon />}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="body1" data-testid="transactionAction">
                                {transactionAction}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography variant="subtitle2" data-testid="transactionCreatedAt">
                                <TimeStamp value={transaction.createdAt} />
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Collapse in={open} timeout="auto" unmountOnExit style={{ marginBottom: 10 }}>
                <Card variant="outlined">
                    <CardContent className={styles.Shaded__light}>
                        {transactionMetadata.map((e, i) => {
                            return (
                                <div
                                    key={`metadata_${i}`}
                                    className={styles.TransactionCardMetadata__section__info}
                                >
                                    <p
                                        className={styles.TransactionCardMetadata__section__label}
                                        data-testid={`${e.label}_label`}
                                    >
                                        {e.label}
                                    </p>
                                    <p
                                        className={styles.TransactionCardMetadata__section__data}
                                        data-testid={`${e.label}_data`}
                                    >
                                        {e.data}
                                    </p>
                                </div>
                            )
                        })}
                    </CardContent>
                </Card>
            </Collapse>
        </div>
    )
}
